import { useWave } from "@otta/search/hooks/useWelcomeToTheJungle";

export function useHasNewLogo(): boolean {
  return useWave() == "wave2";
}
